import { useCallback } from 'react';
import { useUserStore } from '../store/useUserStore';
import { userApi } from '../assets/api/apis';
import { User, Kid } from '../types';

// token 정보는 건드리지 않고 유저 정보만 업데이트
export default function useUpdateUser() {
  const setUser = useUserStore((s) => s.setUser);
  const updateUser = useCallback(async () => {
    try {
      const res = await userApi.getMyInfo();
      const userInfo = res.data as User & { kids: Kid[] };
      setUser((prev) => {
        const kids = userInfo?.kids ?? [];
        // 선택해 둔 아이가 목록에 남아 있으면 유지한다(user-172)
        const selectedKid = prev.mainKid
          ? kids.find((kid) => kid.id === prev.mainKid?.id)
          : undefined;
        return {
          ...prev,
          ...userInfo,
          mainKid: selectedKid || kids[0] || null,
        };
      });
    } catch (error) {
      console.error('useUpdateUserInfo load error:', error);
    }
  }, [setUser]);

  return { updateUser };
}
